// Important notes when using this component
// - TemplateBlueprints is a function that takes a template number, and props object
// - The props object should be an object with the necessary props for the template
// - The props object will map the props from left to right and top to bottom in the template
//  - If you have four props, they will be placed in the top left, top right, bottom left, and bottom right of the template in that order

const blankTemplate = () => {
  return [
    {
      type: 'blank',
      size: 'full',
      props: {},
    },
  ]
}

const template1 = (props) => {
  return [
    {
      id: 'template1-1',
      size: 'full',
      type: 'image',
      props: { ...props, isHeading: true },
    },
  ]
}

// THIS TEMPLATE THE SURNAME TEMPLATE
const template2 = (props) => {
  return [{ templateId: 2, props: props || {}, type: 'surname', size: 'full' }]
}

const template3 = (props) => {
  return [
    {
      templateId: 3,
      size: 'full',
      type: 'image',
      props: props ? props[0] : {},
    },
  ]
}

const template4 = (props) => {
  return [
    {
      templateId: 4,
      size: 'full',
      type: 'image',
      props: props ? props[0] : {},
    },
  ]
}

const template5 = (props) => {
  return [
    {
      id: 'template5-1',
      size: 'half',
      type: 'image',
      props: props ? props[0] : {},
    },
    {
      id: 'template5-2',
      size: 'half',
      type: 'image',
      props: props ? props[1] : {},
    },
  ]
}

const template6 = (props) => {
  return [
    {
      id: 'template6-1',
      size: 'half',
      type: 'image',
      props: props ? props[0] : {},
    },
    {
      id: 'template6-2',
      size: 'quarter',
      type: 'image',
      props: props ? props[1] : {},
    },
    {
      id: 'template6-3',
      size: 'quarter',
      type: 'image',
      props: props ? props[2] : {},
    },
  ]
}

const template7 = (props) => {
  return [
    {
      id: 'template7-1',
      size: 'quarter',
      type: 'image',
      props: props ? props[0] : {},
    },
    {
      id: 'template7-2',
      size: 'quarter',
      type: 'image',
      props: props ? props[1] : {},
    },
    {
      id: 'template7-3',
      size: 'half',
      type: 'image',
      props: props ? props[2] : {},
    },
  ]
}

const template8 = (props) => {
  return [
    {
      id: 'template8-1',
      size: 'quarter',
      type: 'image',
      props: props ? props[0] : {},
    },
    {
      id: 'template8-2',
      size: 'quarter',
      type: 'text',
      props: props ? props[1] : {},
    },
    {
      id: 'template8-3',
      size: 'half',
      type: 'image',
      props: props ? props[2] : {},
    },
  ]
}

const template9 = (props) => {
  return [
    {
      id: 'template9-1',
      size: 'quarter',
      type: 'text',
      props: props ? props[0] : {},
    },
    {
      id: 'template9-2',
      size: 'quarter',
      type: 'image',
      props: props ? props[1] : {},
    },
    {
      id: 'template9-3',
      size: 'half',
      type: 'image',
      props: props ? props[2] : {},
    },
  ]
}

const template10 = (props) => {
  return [
    {
      id: 'template10-1',
      size: 'half',
      type: 'image',
      props: props ? props[0] : {},
    },
    {
      id: 'template10-2',
      size: 'quarter',
      type: 'image',
      props: props ? props[1] : {},
    },
    {
      id: 'template10-3',
      size: 'quarter',
      type: 'text',
      props: props ? props[2] : {},
    },
  ]
}

const template11 = (props) => {
  return [
    {
      id: 'template11-1',
      size: 'half',
      type: 'image',
      props: props ? props[0] : {},
    },
    {
      id: 'template11-2',
      size: 'quarter',
      type: 'text',
      props: props ? props[1] : {},
    },
    {
      id: 'template11-3',
      size: 'quarter',
      type: 'image',
      props: props ? props[2] : {},
    },
  ]
}

const template12 = (props) => {
  return [
    {
      id: 'template12-1',
      size: 'quarter',
      type: 'image',
      props: props ? props[0] : {},
    },
    {
      id: 'template12-2',
      size: 'quarter',
      type: 'image',
      props: props ? props[1] : {},
    },
    {
      id: 'template12-3',
      size: 'quarter',
      type: 'image',
      props: props ? props[2] : {},
    },
    {
      id: 'template12-4',
      size: 'quarter',
      type: 'image',
      props: props ? props[3] : {},
    },
  ]
}

const template13 = (props) => {
  return [
    {
      id: 'template13-1',
      size: 'half',
      type: 'image',
      props: props ? props[0] : {},
    },
    {
      id: 'template13-2',
      size: 'half',
      type: 'text',
      props: props ? props[1] : {},
    },
  ]
}

const template14 = (props) => {
  return [
    {
      id: 'template14-1',
      size: 'half',
      type: 'text',
      props: props ? props[0] : {},
    },
    {
      id: 'template14-2',
      size: 'half',
      type: 'image',
      props: props ? props[1] : {},
    },
  ]
}

const template15 = (props) => {
  return [
    {
      id: 'template15-1',
      size: 'full',
      type: 'text',
      props: props ? props[0] : {},
    },
  ]
}

// TREE DESIGNS TEMPLATE
const template16 = (props) => {
  return [
    {
      id: 'template16-1',
      props: props ? props[0] : {},
      size: 'full',
      type: 'image',
    },
  ]
}

// GLOBAL SURNAME TEMPLATE
const template17 = (props) => {
  return [{ templateId: 17, props: props || {}, type: 'globalSurname', size: 'full' }]
}

// BACK PAGE TEMPLATE
const template18 = (props) => {
  return [{ templateId: 18, props: props || {}, type: 'backPage', size: 'full' }]
}

// CREATE YOUR OWN TEMPLATE
const template19 = (props) => {
  return [{ templateId: 19, props: props || {}, type: 'createYourOwn', size: 'full' }]
}

// FAN CHART TEMPLATE
const template20 = (props) => {
  return [{ templateId: 20, props: props || {}, type: 'fanChart', size: 'full' }]
}

const TemplateBlueprints = (templateNumber, props) => {
  switch (templateNumber) {
    case 0:
      return blankTemplate()
    case 1:
      return template1(props)
    case 2:
      return template2(props)
    case 3:
      return template3(props)
    case 4:
      return template4(props)
    case 5:
      return template5(props)
    case 6:
      return template6(props)
    case 7:
      return template7(props)
    case 8:
      return template8(props)
    case 9:
      return template9(props)
    case 10:
      return template10(props)
    case 11:
      return template11(props)
    case 12:
      return template12(props)
    case 13:
      return template13(props)
    case 14:
      return template14(props)
    case 15:
      return template15(props)
    case 16:
      return template16(props)
    case 17:
      return template17(props)
    case 18:
      return template18(props)
    case 19:
      return template19(props)
    case 20:
      return template20(props)
    default:
      return blankTemplate()
  }
}

export default TemplateBlueprints
